import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { renderServerComponent } from "@tanstack/react-start/rsc";
import { ENABLE_ACCURACY_PAGE, TITLE } from "shared/SharedConstants";
import TrustContent from "src/components/policies/TrustContent";
import { metadataHead } from "src/lib/Metadata";
import { withHydrationMarker } from "src/lib/ServerContent";
import { renderCachedServerComponent } from "src/server/FlightCache";

// A server component, like the Terms (src/routes/_policies/terms.tsx).
const getTrustContent = createServerFn({ method: "GET" }).handler(() =>
  renderCachedServerComponent("policy:trust", () =>
    renderServerComponent(withHydrationMarker(<TrustContent />)),
  ),
);

export const Route = createFileRoute("/_policies/trust")({
  loader: () => getTrustContent(),
  // The text only changes with a deploy.
  staleTime: Number.POSITIVE_INFINITY,
  head: () =>
    metadataHead({
      title: "Trust",
      description: `How ${TITLE} processes, stores and protects content: moderation providers, subprocessors, storage regions, retention, security and ${ENABLE_ACCURACY_PAGE ? "accuracy" : "moderation limits"}.`,
      alternates: { canonical: "/trust" },
    }),
  component: () => <>{Route.useLoaderData()}</>,
});
